import GeneralReports from './GeneralReports';

export {
  GeneralReports
};

export default GeneralReports;